import React from 'react'
import PropTypes from 'prop-types'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles(theme => ({
    mailingFormWrapper: {
        width: '100%',
    },
}))

const FormLayoutFull = ({ children }) => {
    const classes = useStyles()
    return <div className={classes.mailingFormWrapper}>{children}</div>
}

FormLayoutFull.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
}

export default FormLayoutFull
